import { ReflectUtils } from '@dooboostore/core';
import { MetaDataPropertyAtomic } from '../MetaDataAtomic';
import { ObjectUtils } from '@dooboostore/core';
import { ConstructorType } from '@dooboostore/core';
import { ReflectMethod } from '../../types/Types';

const AfterMetadataKey = Symbol.for('simple-boot:after-metadata');
const BeforeMetadataKey = Symbol.for('simple-boot:before-metadata');
const AroundMetadataKey = Symbol.for('simple-boot:around-metadata');
type AOPOption = { type?: ConstructorType<any>; property: string };
type AroundOption = {
  before?: (obj: any, propertyKey: string, args: any[]) => any[];
  after?: (obj: any, propertyKey: string, args: any[], beforeReturn: any) => any[];
};

// after
export const After = (data: AOPOption) => {
  return ReflectUtils.metadata(AfterMetadataKey, data);
};
export const getAfter = (target: any, propertyKey: string): AOPOption | undefined => {
  return ReflectUtils.getMetadata(AfterMetadataKey, target, propertyKey);
};

export const getAfters = (target: any): MetaDataPropertyAtomic<any, AOPOption | undefined>[] => {
  return (
    ObjectUtils.allProtoTypeName(target)
      .map(it => new MetaDataPropertyAtomic<any, AOPOption | undefined>(target, getAfter(target, it), it))
      .filter(it => it.metaData !== undefined) || []
  );
};

export const getProtoAfters = (
  target: any,
  propertyKey: string,
  type?: ConstructorType<any>
): MetaDataPropertyAtomic<any, AOPOption | undefined>[] => {
  return (
    getAfters(target).filter(it => propertyKey === it.metaData?.property && type === it.metaData.type?.prototype) || []
  );
};

// before
export const Before = (data: AOPOption) => {
  return ReflectUtils.metadata(BeforeMetadataKey, data);
};

export const getBefore = (target: any, propertyKey: string): AOPOption | undefined => {
  return ReflectUtils.getMetadata(BeforeMetadataKey, target, propertyKey);
};

export const getBefores = (target: any): MetaDataPropertyAtomic<any, AOPOption | undefined>[] => {
  return (
    ObjectUtils.allProtoTypeName(target)
      .map(it => new MetaDataPropertyAtomic<any, AOPOption | undefined>(target, getBefore(target, it), it))
      .filter(it => it.metaData !== undefined) || []
  );
};

export const getProtoBefores = (
  target: any,
  propertyKey: string,
  type?: ConstructorType<any>
): MetaDataPropertyAtomic<any, AOPOption | undefined>[] => {
  return (
    getBefores(target).filter(it => propertyKey === it.metaData?.property && type === it.metaData.type?.prototype) || []
  );
};

export class AroundForceReturn {
  constructor(public value: any) {}
}
// around
export const Around = (config: AroundOption): ReflectMethod => {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    ReflectUtils.defineMetadata(AroundMetadataKey, config, target, propertyKey);

    const method = descriptor.value;
    descriptor.value = function (...args: any[]) {
      // console.log('check method')

      let before: any = undefined;
      let r: any = undefined;
      if (config.before) {
        try {
          before = config.before?.(this, propertyKey, args);
        } catch (e) {
          if (e instanceof AroundForceReturn) {
            return e.value;
          }
        }
        r = method.apply(this, before);
      } else {
        r = method.apply(this, args);
      }

      if (config.after) {
        try {
          r = config.after?.(this, propertyKey, args, r);
        } catch (e) {
          if (e instanceof AroundForceReturn) {
            return e.value;
          }
        }
      }
      return r;
    };
  };
};

export const getAround = (target: any, propertyKey: string): AroundOption | undefined => {
  return ReflectUtils.getMetadata(AroundMetadataKey, target, propertyKey);
};

// Aliases for lowercase
export const after = After;
export const before = Before;
export const around = Around;
